import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { API_ERROR_CODES } from '../constants/api.error.code.constants';

export function errorInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unknown error occurred';

      if (error.status === API_ERROR_CODES['400'].code) {
        errorMessage = API_ERROR_CODES['400'].message;
      } else if (error.status === API_ERROR_CODES['404'].code) {
        errorMessage = API_ERROR_CODES['404'].message;
      } else if (error.status === API_ERROR_CODES['422'].code) {
        errorMessage = API_ERROR_CODES['422'].message;
      } else if (error.status === API_ERROR_CODES['503'].code) {
        errorMessage = API_ERROR_CODES['503'].message;
      } else if (error.status === API_ERROR_CODES['409'].code) {
        errorMessage = error.error || API_ERROR_CODES['409'].message;
      }
      return throwError(() => new Error(errorMessage));
    }),
  );
}
